export default __webpack_public_path__ + "static/control-panel-782301ecd6a3e9b69a70b31bee3bf74c.jpg";